import draggAble from './drag.js'

export default draggAble



// WEBPACK FOOTER //
// ./src/components/drag/index.js